import { Typography } from "@mui/material";

import { EpisodicExemptLbs, episodicExemptLabel } from "./generatorStatusDisplay";

export function EpisodicExemptCaption({ lbs }: { lbs: EpisodicExemptLbs }) {
  const label = episodicExemptLabel(lbs);
  if (!label) return null;
  return (
    <Typography variant="caption" component="div">
      {label}
    </Typography>
  );
}
